import React from "react";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";

import "./SuccessModal.css";

const VARIANT_DEFAULTS = {
  success: {
    title: "Subscription Updated Successfully!",
    description: "Credits have been added to your subscription plan.",
  },
  failed: {
    title: "Payment Failed",
    description: "Your payment could not be completed. Please try again.",
  },
};

export default function SuccessModal({
  open,
  onClose,
  variant = "success",
  title,
  description,
  showCloseButton = false,
}) {
  const isFailed = variant === "failed";
  const defaults = VARIANT_DEFAULTS[isFailed ? "failed" : "success"];
  const resolvedTitle = title ?? defaults.title;
  const resolvedDescription = description ?? defaults.description;
  const shouldShowCloseButton = showCloseButton || isFailed;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      destroyOnHidden
      width={480}
      className={`SuccessModal${isFailed ? " SuccessModal--failed" : ""}`}
    >
      {shouldShowCloseButton && (
        <button
          type="button"
          className="SuccessModal__CloseButton"
          onClick={onClose}
          aria-label={isFailed ? "Close payment failed modal" : "Close success modal"}
        >
          <CloseOutlined />
        </button>
      )}

      <div className="SuccessModal__Content">
        <span
          className={`SuccessModal__Icon${isFailed ? " SuccessModal__Icon--failed" : ""}`}
          aria-hidden
        >
          {isFailed ? <CloseOutlined /> : <CheckOutlined />}
        </span>

        <h2 className="SuccessModal__Title">{resolvedTitle}</h2>
        {resolvedDescription ? (
          <p className="SuccessModal__Description">{resolvedDescription}</p>
        ) : null}
      </div>
    </Modal>
  );
}
